import React, { Component } from "react";

import { AiOutlinePicture } from "react-icons/ai";
import CircularIcon from "Components/CircularIcon";
import CommentForm from "Forms/CommentForm";
import { FaComment } from "react-icons/fa";
import { IoIosRocket } from "react-icons/io";
import LinksList from "Components/LinksList";
import ProjectImages from "Components/ProjectImages";
import ProjectUpdate from "Components/ProjectUpdate";
import SideProject from "Components/SideProject";
import { connect } from "react-redux";
import navRoutes from "Navigation/NavRoutes";
import styles from "./styles.module.scss";

class Orbiter extends Component {
  state = {
    type: "updates",
  };

  truncateProjectDetails = (details) => {
    let newDetails = details;
    if (details.length > 30) {
      newDetails = `${details
        .split("")
        .splice(0, 150)
        .join("")}...`;
    }
    return <div className={styles.projectName}>{newDetails}</div>;
  };

  render() {
    const {
      editable,
      projectDetails,
      user,
      navigateToUpdate,
      handleSubmitComment,
      sendingComment,
      commentError,
      onImageClick,
      renderComments,
      history,
      addProjectUpdate,
      removeProjectUpdate,
      removeProjectImage,
      addProjectImages,
    } = this.props;
    const { type } = this.state;
    const {
      projectDescription,
      projectLinks,
      projectUpdates,
      projectImages,
      projectManager,
      projectAvatar,
    } = projectDetails;
    return (
      <>
        <div className={styles.container}>
          <div className={styles.topContainer}>
            <div className={styles.sideProject}>
              <SideProject showTitle showRating project={projectDetails} />
            </div>
            <div className={styles.projectInfo}>
              {projectDescription &&
                this.truncateProjectDetails(projectDescription)}
              <div className={styles.projectLinks}>
                <LinksList
                  editable={editable}
                  projectResources={projectLinks}
                  customLinkImage={projectAvatar}
                />
              </div>
              <div className={styles.userAvatar}>
                <CircularIcon
                  icon={user.avatar}
                  text={user.firstName}
                  onClick={() =>
                    history.push(`${navRoutes.profile}/${projectManager.id}`)
                  }
                />
              </div>
            </div>
          </div>
          <div className={styles.bottomContainer}>
            <span
              className={
                type === "updates" ? styles.typeIconSelected : styles.typeIcon
              }
              onClick={() => this.setState({ type: "updates" })}
            >
              <CircularIcon defaultIcon={IoIosRocket} />
            </span>
            <span
              className={
                type === "comments" ? styles.typeIconSelected : styles.typeIcon
              }
              onClick={() => this.setState({ type: "comments" })}
            >
              <CircularIcon defaultIcon={FaComment} />
            </span>
            <span
              className={
                type === "images" ? styles.typeIconSelected : styles.typeIcon
              }
              onClick={() => this.setState({ type: "images" })}
            >
              <CircularIcon defaultIcon={AiOutlinePicture} />
            </span>
          </div>
          {type === "updates" ? (
            <ProjectUpdate
              editable={editable}
              updates={projectUpdates}
              addUpdate={() => addProjectUpdate()}
              removeUpdate={(id) => removeProjectUpdate(id)}
              onClick={navigateToUpdate}
            />
          ) : type === "comments" ? (
            <div className={styles.commentContainer}>
              <CommentForm
                handleSubmit={handleSubmitComment}
                fetching={sendingComment}
                commentError={commentError}
              />
              {renderComments}
            </div>
          ) : type === "images" ? (
            <ProjectImages
              editable={editable}
              projectImages={projectImages}
              onRemoveClick={(id) => removeProjectImage(id)}
              onAddClick={() => addProjectImages()}
              onImageClick={onImageClick}
            />
          ) : null}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(Orbiter);
